import * as Yup from 'yup';
import { FIELD_LIMITS } from 'src/utils';

const onCreate = { is: (id?: string) => !id };

/**
 * @registry Yup shape for the fields WorkflowRecordFields owns. Title, Assignee and Company
 * are required on create only (no id), matching the server validators. Spread it into a
 * module form's schema.
 */
export const workflowRecordFieldSchema = {
  title: Yup.string()
    .nullable()
    .max(
      FIELD_LIMITS.singleLine,
      `Title must be ${FIELD_LIMITS.singleLine} characters or fewer`,
    )
    .when('id', {
      ...onCreate,
      then: (schema) =>
        schema.required('Title is required').min(1, 'Title is required'),
    })
    .label('Title'),
  assigneeUserId: Yup.number()
    .nullable()
    .when('id', {
      ...onCreate,
      then: (schema) => schema.required('Assignee is required'),
    }),
  company: Yup.string()
    .nullable()
    .max(
      FIELD_LIMITS.singleLine,
      `Company Name must be ${FIELD_LIMITS.singleLine} characters or fewer`,
    )
    .when('id', {
      ...onCreate,
      then: (schema) =>
        schema
          .required('Company name is required')
          .min(1, 'Company name is required'),
    }),
};
